<template>
  <div class="add_new_inner wrap-surg-add">
    <div class="subtitle center no_mobile">
      בקשות מטופל לבית החולים
    </div>
    <h2 class="subtitle_inner mobile_only">
      בקשות מטופל לבית החולים
    </h2>

    <form @submit.prevent="onSubmit">
      <div
        class="book_surgery toggleContainer desk_inner_width active"
        :class="{ 'patient-requests--with-categories': categoriesEnabled }"
      >
        <a class="book_surgery_top flex" @click.prevent="toggleSection">
          <span
            class="title"
            :class="{
              'flex is--fit desk-flex--between': notesRequired
            }"
          >
            {{ notesLabel }}
            <Tags v-if="notesRequired" :isRequired="true" />
          </span>
          <span class="plus-wrap flex m-flex--center">
            <span class="plus"></span>
          </span>
        </a>

        <div
          class="book_surgery_open toggleInner"
          :style="{ display: sectionExpanded ? 'block' : 'none' }"
        >
          <div class="inner_group bg--white desk-no-pad">
            <div
              v-if="categoriesEnabled"
              class="add_new_row flex patient-request-types-row"
            >
              <div class="add_new_row_col1">סוג הבקשה</div>
              <div class="add_new_row_col2 w-100">
                <div class="patient-request-toggle-grid">
                  <div
                    v-for="option in options"
                    :key="option.value"
                    class="sur_order flex flex--start"
                    @click="toggleType(option.value)"
                  >
                    <button
                      type="button"
                      class="sur_order_swipe"
                      :class="{
                        active: formData.types.includes(option.value)
                      }"
                      :aria-pressed="formData.types.includes(option.value)"
                    >
                      <span class="swipe_in ease"></span>
                    </button>
                    <div class="sur_order_tx">{{ option.text }}</div>
                  </div>
                </div>
              </div>
            </div>

            <div class="patient-request-notes-field">
              <textarea
                v-model="formData.notes"
                :placeholder="notesPlaceholder"
                maxlength="1000"
                autocomplete="off"
                @input="notesError = ''"
              ></textarea>
              <span v-if="notesError" class="error-message">{{
                notesError
              }}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="surg-bottom-actions center">
        <button type="submit" class="bt_blue">המשך לאישור</button>
      </div>
    </form>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapState } from "vuex";
import Tags from "@/components/Dashboard/Surgery/AddSurgery/Steps/SurgeryDetails/modules/Tags.vue";
import {
  createEmptyPatientRequests,
  getPatientRequestNotesLabel,
  getPatientRequestNotesPlaceholder,
  isPatientRequestNotesRequired,
  PATIENT_REQUEST_CATEGORIES_ENABLED,
  PATIENT_REQUEST_OPTIONS
} from "@/utilities/patient-requests";

export default {
  name: "PatientRequests",
  components: { Tags },
  data() {
    return {
      options: PATIENT_REQUEST_OPTIONS,
      categoriesEnabled: PATIENT_REQUEST_CATEGORIES_ENABLED,
      formData: createEmptyPatientRequests(),
      notesError: "",
      sectionExpanded: true
    };
  },
  computed: {
    ...mapState("Surgery", ["surgery"]),
    ...mapGetters("Surgery", ["showImplantsSection"]),
    approvalStep() {
      return this.showImplantsSection ? 8 : 7;
    },
    notesRequired() {
      return isPatientRequestNotesRequired(this.formData.types);
    },
    notesLabel() {
      return getPatientRequestNotesLabel(this.formData.types);
    },
    notesPlaceholder() {
      return getPatientRequestNotesPlaceholder(this.formData.types);
    }
  },
  created() {
    const requests = this.surgery.patient_requests;
    if (!requests) return;

    this.formData = {
      types: PATIENT_REQUEST_CATEGORIES_ENABLED
        ? Array.isArray(requests.types)
          ? [...requests.types]
          : []
        : [],
      notes: requests.notes || ""
    };
  },
  methods: {
    ...mapMutations("Surgery", ["SET_SURGERY", "SET_CURRENT_STEP"]),
    toggleSection() {
      this.sectionExpanded = !this.sectionExpanded;
    },
    toggleType(type) {
      const index = this.formData.types.indexOf(type);
      if (index === -1) {
        this.formData.types.push(type);
      } else {
        this.formData.types.splice(index, 1);
      }
      this.notesError = "";
    },
    onSubmit() {
      if (this.notesRequired && !this.formData.notes.trim()) {
        this.notesError = "שדה חובה";
        this.sectionExpanded = true;
        return;
      }

      this.notesError = "";
      this.SET_SURGERY({
        patient_requests: {
          types: PATIENT_REQUEST_CATEGORIES_ENABLED
            ? [...this.formData.types]
            : [],
          notes: this.formData.notes.trim()
        }
      });
      this.SET_CURRENT_STEP(this.approvalStep);
    }
  }
};
</script>

<style scoped>
.wrap-surg-add .subtitle,
.wrap-surg-add .subtitle_inner {
  font-weight: 300;
}

.patient-request-toggle-grid {
  align-items: start;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px 16px;
}

.patient-request-toggle-grid .sur_order {
  font-size: 23px;
  min-width: 0;
}

.patient-request-notes-field {
  box-sizing: border-box;
  padding: 16px;
  width: 100%;
}

.patient-request-notes-field textarea {
  background: #eeeeee;
  border: none;
  border-bottom: 1px solid #324997;
  box-sizing: border-box;
  display: block;
  font-size: 25px;
  min-height: 140px;
  padding: 12px;
  resize: vertical;
  width: 100%;
}

.patient-request-types-row {
  width: 100%;
  padding: 12px;
}

@media only screen and (max-width: 800px) {
  .patient-request-toggle-grid {
    grid-template-columns: 1fr;
  }

  .patient-request-toggle-grid .sur_order {
    font-size: 21px;
  }
}
</style>
